import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebarMenu } from '@app/store/reducers/ui';   //  toggleControlSidebar
// import {Button} from '@app/components';
// import MessagesDropdown from '@app/modules/main/header/messages-dropdown/MessagesDropdown';
// import NotificationsDropdown from '@app/modules/main/header/notifications-dropdown/NotificationsDropdown';
// import LanguagesDropdown from '@app/modules/main/header/languages-dropdown/LanguagesDropdown';
import UserDropdown from '@app/modules/main/header/user-dropdown/UserDropdown';
import { loginUser, setPermissions, setSelectedRole, setSelectedStudent } from '@app/store/reducers/auth';
import { toast } from 'react-toastify';
import { getCompactPermissionByRoleId } from '@app/services/permission';
import { selectRole } from '@app/services/auth';
import { confirmAlert } from 'react-confirm-alert';
let base64 = require('base-64');
let utf8 = require('utf8');

const Header = () => {
	const dropdownRef = useRef<any>(null);
	const [t] = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navbarVariant = useSelector((state: any) => state.ui.navbarVariant);
	const headerBorder = useSelector((state: any) => state.ui.headerBorder);
	const currentUser = useSelector((state: any) => state.auth.currentUser);
	const selectedRole = useSelector((state: any) => state.auth.selectedRole);
	const selectedStudent = useSelector((state: any) => state.auth.selectedStudent);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside, false);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside, false);
		};
	});

	const handleClickOutside = (event: any) => {
		if (
			dropdownRef &&
			dropdownRef.current &&
			!dropdownRef.current.contains(event.target)
		) {
			setDropdownOpen(false);
		}
	};

	const toggleDropdown = () => {
		setDropdownOpen(!dropdownOpen);
	};

	const handleRoleSwitch = async (role) => {
		try {
			confirmAlert({
				title: 'Switch Role!',
				message: 'Do you want to switch to the ' + role.name + '?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							// Step 1: select role → get new token
							const selectResp = await selectRole(role.id);
							if (selectResp?.success === true) {
								dispatch(loginUser(selectResp.token));
							}
							// Step 2: get permissions directly
							const permResp = await getCompactPermissionByRoleId(role.id);
							if (permResp?.success === true) {
								toast.success('Role switched successfully.')
								dispatch(setSelectedRole(role));
								dispatch(setPermissions(permResp.collections));
								navigate('/');
							} else {
								toast.error(permResp?.message);
							}
						}
					},
					{
						label: 'No',
						onClick: () => { }
					}
				]
			});
		} catch (error: any) {
			// setAuthLoading(false);
			toast.error(error?.message || 'Something went wrong');
		}
	}

	const handleStudentSwitch = (student) => {
		confirmAlert({
			title: 'Switch Student!',
			message: 'Do you want to switch to the `' + student.first_name + ' ' + student.last_name + '`?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						dispatch(setSelectedStudent(student))
						navigate('/');
					}
				},
				{
					label: 'No',
					onClick: () => { }
				}
			]
		});
	};

	const handleToggleMenuSidebar = () => {
		dispatch(toggleSidebarMenu());
	};

	// const handleToggleControlSidebar = () => {
	//   dispatch(toggleControlSidebar());
	// };

	const getContainerClasses = useCallback(() => {
		let classes = `main-header navbar navbar-expand ${navbarVariant}`;
		if (headerBorder) {
			classes = `${classes} border-bottom-0`;
		}
		return classes;
	}, [navbarVariant, headerBorder]);

	return (
		<nav className={getContainerClasses()}>
			<ul className="navbar-nav">
				<li className="nav-item">
					<button
						onClick={handleToggleMenuSidebar}
						type="button"
						className="nav-link"
					>
						<i className="fas fa-bars" />
					</button>
				</li>
				{/* <li className="nav-item d-none d-sm-inline-block">
				<Link to="/" className="nav-link">
					{t('header.label.home')}
				</Link>
				</li>
				<li className="nav-item d-none d-sm-inline-block">
				<Link to="/" className="nav-link">
					{t('header.label.contact')}
				</Link>
				</li> */}
			</ul>
			<ul className="navbar-nav ml-auto">
				{ selectedRole?.slug != 'parent' && (
					<li className="nav-item dropdown" ref={dropdownRef} onClick={toggleDropdown}>
						<button type="button" className="nav-link"><i className="fas fa-people-arrows" /></button>
						<div className={dropdownOpen ? "dropdown-menu dropdown-menu-right dropdown-menu-md show" : "dropdown-menu dropdown-menu-right dropdown-menu-md"} style={{ left: 'inherit', right: 0, padding: 0 }}>
							{currentUser.roles && currentUser.roles.map((role) => (
								<button
									key={role.id} type="button"
									className={selectedRole?.id === role.id ? "dropdown-item active" : "dropdown-item"}
									onClick={() => {
										handleRoleSwitch(role);
										setDropdownOpen(false);
									}}>
									<i className={selectedRole?.id === role.id ? "fas fa-check mr-2" : "fas fa-circle mr-2"} />
									<span>{role.name}</span>
								</button>
							))}
						</div>
					</li>
				)}

				{ selectedRole?.slug == 'parent' && currentUser?.students?.length > 0 && (
					<li className="nav-item dropdown" ref={dropdownRef} onClick={toggleDropdown}>
						<button type="button" className="nav-link"><i className="fas fa-people-arrows" /></button>
						<div className={dropdownOpen ? "dropdown-menu dropdown-menu-right dropdown-menu-md show" : "dropdown-menu dropdown-menu-right dropdown-menu-md"} style={{ left: 'inherit', right: 0, padding: 0 }}>
							{currentUser.students && currentUser.students.map((student) => (
								<button
									key={student.id} type="button"
									className={selectedStudent.id === student.id ? "dropdown-item active" : "dropdown-item"}
									onClick={() => {
										handleStudentSwitch(student);
										setDropdownOpen(false);
									}}>
									<i className={selectedRole.id === student.id ? "fas fa-check mr-2" : "fas fa-circle mr-2"} />
									<span>{student.first_name + ' ' + student.last_name}</span>
								</button>
							))}
						</div>
					</li>
				)}
				<UserDropdown />
				{/*
				<LanguagesDropdown />
				<MessagesDropdown />
				<NotificationsDropdown /> 
				<li className="nav-item">
				<Button className="nav-link" onClick={handleToggleControlSidebar}>
					<i className="fas fa-th-large" />
				</Button>
				</li> 
				*/}
			</ul>
		</nav>
	);
};

export default Header;